<template>
  <b-container fluid>
    <b-row>
      <b-col md="4">
        <b-input-group size="sm">
          <b-form-datepicker id="fromDate" v-model="from" size="sm"></b-form-datepicker>

          <b-button variant="outline-secondary" size="sm" @click="refreshStats">
            <b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise>
          </b-button>
        </b-input-group>

        <b-form-datepicker id="toDate" v-model="to" class="mb-2" size="sm"></b-form-datepicker>
      </b-col>
      <b-col>
        <inventory-tally />
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col md="4">
        <order-stats :from="from" :to="to" :refresh="refresh"></order-stats>
      </b-col>
      
      <b-col md="4">
        <inventory-stats :from="from" :to="to" :refresh="refresh"></inventory-stats>
        <bad-items class="mt-5"></bad-items>
      </b-col>

      <b-col md="4">
        <schedule :from="from" :to="to" :refresh="refresh"></schedule>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import moment from "moment";
  import OrderStats from "@/components/stats/OrderStats";
  import InventoryStats from "@/components/stats/InventoryStats";
  import InventoryTally from "@/components/stats/InventoryTally";
  import Schedule from "@/components/stats/Schedule";
  import BadItems from "@/components/stats/BadItems";

  export default {
    name: 'Dashboard',
    components: {
      Schedule,
      OrderStats,
      InventoryStats,
      InventoryTally,
      BadItems,
    },
    data() {
      return {
        from: null,
        to: null,
        refresh: 0,
      }
    },
    mounted() {
      this.from = moment().format('YYYY-MM-DD');
    },
    methods: {
      refreshStats() {
        this.from = moment().format('YYYY-MM-DD');
        this.to = null;
        this.refresh += 1;
      },
    },
  }
</script>